jQuery(document).ready(function($){

    let viewport = $(window).width();

    $('#burger-nav').click(() => {
        $('#burger-nav').toggleClass('open');
        $('.mobile-nav').toggleClass('open');
        $('html').toggleClass('no-scroll');
        $('body').toggleClass('no-scroll');
        $([document.documentElement, document.body]).animate({
            scrollTop: $('main').offset().top
        }, 500);
        if (viewport < 770) {
            $('.header-share').toggleClass('hide');
            $('.header-sign').toggleClass('hide');
        }
    });

    const mobilePopupTrigger = document.querySelector('.mobile-nav .menu-item-152');
    const signNow = document.getElementById('sign-now');
    const supportGail = document.getElementById('support-gail');
    const popupTrigger = document.getElementById('menu-item-152');
    const footerPopupTrigger = document.getElementById('menu-item-199')
    const petitionPopup = document.getElementById('petition-popup');
    const closePopup = document.getElementById('close-popup');

    $(popupTrigger).click((e) => {
        e.preventDefault();
        $(petitionPopup).fadeIn();
        $([document.documentElement, document.body]).animate({
            scrollTop: $('main').offset().top
        }, 500);
        if (viewport < 770) {
            $('main').hide();
            $('html').removeClass('no-scroll');
        }
    });
    $(mobilePopupTrigger).click((e) => {
        e.preventDefault();
        $(petitionPopup).fadeIn();
        $([document.documentElement, document.body]).animate({
            scrollTop: $('main').offset().top
        }, 500);
        if (viewport < 770) {
            $('main').hide();
            $('html').removeClass('no-scroll');
        }
    });
    $(signNow).click((e) => {
        e.preventDefault();
        $(petitionPopup).fadeIn();
        $([document.documentElement, document.body]).animate({
            scrollTop: $('main').offset().top
        }, 500);
    });
    $(footerPopupTrigger).click((e) => {
        e.preventDefault();
        $(petitionPopup).fadeIn();
        $([document.documentElement, document.body]).animate({
            scrollTop: $('main').offset().top
        }, 500);
    });
    $(supportGail).click((e) => {
        e.preventDefault();
        $(petitionPopup).fadeIn();
        $([document.documentElement, document.body]).animate({
            scrollTop: $('main').offset().top
        }, 500);t
    });
    $(closePopup).click(() => {
        $(petitionPopup).fadeOut();
        $('main').show();
        if (viewport < 770) {
            $('#burger-nav').removeClass('open');
            $('.mobile-nav').removeClass('open');
        }
    });

    if (document.getElementById('faq')) {
        let faqTitle = document.getElementsByClassName('faq-title');
        let faqSymbol = document.getElementById('faq').querySelectorAll('.fas');
        let faqContent = document.getElementsByClassName('faq-content');
    
        for (let i = 0; i < faqContent.length; i++) {
            $(faqTitle[i]).click(() => {
                $(faqContent[i]).slideToggle();
                $(faqContent).not(faqContent[i]).slideUp();
                $(faqSymbol[i]).toggleClass('fa-minus').toggleClass('fa-plus');
                $(faqSymbol).not(faqSymbol[i]).removeClass('fa-minus').addClass('fa-plus');
            });
        }
    }
    const progressBar = document.getElementById('progress-wrap');

    if (progressBar) {

        const formatter = new Intl.NumberFormat('en');

        function replaceComma(num) {
            return num.replace(/,/g, '');
        };

        const currentCount = document.getElementById('current-count').innerHTML;
        const currentGoal = document.getElementById('goal').innerHTML;
        const progress = document.querySelector('.progress');

        let percentage = replaceComma(currentCount) / replaceComma(currentGoal) * 100;
        let remaining = replaceComma(currentGoal) - replaceComma(currentCount);
     
        document.getElementById('needed').innerHTML = formatter.format(remaining);
        if (document.getElementById('needed-header')) {
            document.getElementById('needed-header').innerHTML = formatter.format(remaining);
        }

        $(progress).css('width', percentage + '%');
    }

});